import { useDispatch } from 'react-redux'
import { useStaffMeta } from '../../hooks/useStaffMeta'
import Loading from '../ui/Loading'
import { clearTypeOfOpen, updateCreateNewStaffField } from '../../features/user/userSlice'
import { RoleType } from '../../types/user'

interface RoleListProps {
    roleList: RoleType[]
}

export default function RoleList({ roleList }: RoleListProps) {

    const dispatch = useDispatch()
    const { isLoadingRoles, isErrorRoles } = useStaffMeta()

    return (
        <ul className="absolute w-full overflow-hidden mt-1 bg-white border rounded shadow-lg z-10 border-gray-400">
            {isLoadingRoles ? (
                <li className='px-3 py-1.5 md:px-5 md:py-2 hover:bg-gray-100 cursor-pointer text-[12px] md:text-[13px] w-full'>
                    <Loading isDefault={false}/>
                </li>
            ) : isErrorRoles ? (
                <li className="px-3 py-1.5 md:px-5 md:py-2 hover:bg-gray-100 cursor-pointer text-[12px] md:text-[13px] w-full">
                    Failed to load roles.
                </li>
            ) : (
                roleList?.map((opt, i) => (
                    <li
                        key={i}
                        onClick={() => {
                            dispatch(updateCreateNewStaffField({ field: 'role', value: opt }))
                            dispatch(clearTypeOfOpen())
                        }}
                        className='px-3 py-1.5 md:px-5 md:py-2 hover:bg-gray-100 cursor-pointer text-xs w-full'
                    >
                        {opt.role}
                    </li>
                ))
            )}
        </ul>
    )
}
